module.exports = __webpack_public_path__ + "static/media/CheckmarkFilled.6ae0d0d8.svg";